<div class="matrix_layoutMain container"  v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12" >                
            <appQuantitySelectionContainer></appQuantitySelectionContainer>  
            <appCostCenter></appCostCenter>
            <appAddToCartButton></appAddToCartButton>                             
        </div>
    </div>    
</div>